export const libraryShowcaseSchema = {
  type: 'library-showcase',
  label: 'Library',
  description: 'MacBook-themed showcase of curated library items',
  icon: 'Laptop',
  defaultContent: {
    title: 'Study Library',
    description: '',
    selectedItems: [],
    buttonText: 'Browse Full Library',
    style: {},
  },
  fields: [],
};
